import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ResultsPage from "./pages/ResultsPage";
import SharedReportPage from "./pages/SharedReportPage";
import ScanPage from "./pages/ScanPage";

function App() {
  useEffect(() => {
    document.title = "UCP Readiness Score";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/report/:analysisId" element={<SharedReportPage />} />
          <Route path="/scan" element={<ScanPage />} />
          <Route path="/scan/:domain" element={<ScanPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
